<section class="page">
  <header class="page-header">
    <button mat-icon-button type="button" (click)="goBack()"><mat-icon>arrow_back</mat-icon></button>
    <div>
      <h1>{{ plan()?.name || 'Test plan' }}</h1>
      <p class="muted">{{ plan()?.description || 'Cases, runs, and summary.' }}</p>
    </div>
  </header>

  @if (error()) { <div class="error">{{ error() }}</div> }
  @if (loading()) { <div class="loading"><mat-spinner diameter="36"></mat-spinner></div> }

  @if (!loading() && plan(); as p) {
    <mat-tab-group>
      <mat-tab label="Cases">
        <div class="tab-body">
          <div class="form-row">
            <mat-form-field appearance="outline" class="grow"><mat-label>Title *</mat-label><input matInput [(ngModel)]="caseTitle"></mat-form-field>
            <button mat-flat-button color="primary" [disabled]="saving() || !caseTitle.trim()" (click)="createCase()">Add case</button>
          </div>
          <mat-form-field appearance="outline" class="full"><mat-label>Description</mat-label><textarea matInput rows="2" [(ngModel)]="caseDescription"></textarea></mat-form-field>
          <mat-form-field appearance="outline" class="full"><mat-label>Steps</mat-label><textarea matInput rows="2" [(ngModel)]="caseSteps"></textarea></mat-form-field>
          <mat-form-field appearance="outline" class="full"><mat-label>Expected result</mat-label><textarea matInput rows="2" [(ngModel)]="caseExpected"></textarea></mat-form-field>

          <table mat-table [dataSource]="cases()" class="full">
            <ng-container matColumnDef="title"><th mat-header-cell *matHeaderCellDef>Title</th><td mat-cell *matCellDef="let c">{{ c.title }}</td></ng-container>
            <ng-container matColumnDef="status"><th mat-header-cell *matHeaderCellDef>Status</th><td mat-cell *matCellDef="let c">{{ caseStatusLabel(c.status) }}</td></ng-container>
            <ng-container matColumnDef="actions"><th mat-header-cell *matHeaderCellDef></th><td mat-cell *matCellDef="let c"><button mat-icon-button color="warn" (click)="deleteCase(c)"><mat-icon>delete</mat-icon></button></td></ng-container>
            <tr mat-header-row *matHeaderRowDef="caseColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: caseColumns"></tr>
          </table>
        </div>
      </mat-tab>

      <mat-tab label="Runs">
        <div class="tab-body">
          <div class="form-row">
            <mat-form-field appearance="outline" class="grow"><mat-label>Run name *</mat-label><input matInput [(ngModel)]="runName"></mat-form-field>
            <button mat-stroked-button [disabled]="saving() || !runName.trim()" (click)="createRun()">Create run</button>
          </div>

          <table mat-table [dataSource]="runs()" class="full">
            <ng-container matColumnDef="name"><th mat-header-cell *matHeaderCellDef>Name</th><td mat-cell *matCellDef="let r">{{ r.name }}</td></ng-container>
            <ng-container matColumnDef="status"><th mat-header-cell *matHeaderCellDef>Status</th><td mat-cell *matCellDef="let r">{{ runStatusLabel(r.status) }}</td></ng-container>
            <ng-container matColumnDef="startedAt"><th mat-header-cell *matHeaderCellDef>Started</th><td mat-cell *matCellDef="let r">{{ r.startedAt || '—' }}</td></ng-container>
            <ng-container matColumnDef="actions"><th mat-header-cell *matHeaderCellDef></th><td mat-cell *matCellDef="let r"><button mat-button (click)="completeRun(r)">Complete</button></td></ng-container>
            <tr mat-header-row *matHeaderRowDef="runColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: runColumns"></tr>
          </table>

          <mat-card class="result-card">
            <mat-card-header><mat-card-title>Record result</mat-card-title></mat-card-header>
            <mat-card-content>
              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>Run</mat-label>
                  <mat-select [(ngModel)]="selectedRunId">
                    @for (r of runs(); track r.id) { <mat-option [value]="r.id">{{ r.name }}</mat-option> }
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Case</mat-label>
                  <mat-select [(ngModel)]="resultCaseId">
                    @for (c of cases(); track c.id) { <mat-option [value]="c.id">{{ c.title }}</mat-option> }
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Result</mat-label>
                  <mat-select [(ngModel)]="resultStatus">
                    @for (s of resultStatuses; track s.value) { <mat-option [value]="s.value">{{ s.label }}</mat-option> }
                  </mat-select>
                </mat-form-field>
              </div>
              <mat-form-field appearance="outline" class="full"><mat-label>Notes</mat-label><textarea matInput rows="2" [(ngModel)]="resultNotes"></textarea></mat-form-field>
              <button mat-flat-button color="primary" [disabled]="saving() || !selectedRunId || !resultCaseId" (click)="recordResult()">Save result</button>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-tab>

      <mat-tab label="Summary">
        <div class="tab-body">
          @if (summaryStats(); as s) {
            <div class="stats">
              <div class="stat"><span>Total runs</span><strong>{{ s.total }}</strong></div>
              <div class="stat"><span>Passed</span><strong>{{ s.passed }}</strong></div>
              <div class="stat"><span>Failed</span><strong>{{ s.failed }}</strong></div>
              <div class="stat"><span>Blocked</span><strong>{{ s.blocked }}</strong></div>
              <div class="stat"><span>Cases</span><strong>{{ cases().length }}</strong></div>
            </div>
          }
        </div>
      </mat-tab>
    </mat-tab-group>
  }
</section>
